import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user.model';
import { Notification } from '../../models/notification.model';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { AuthService } from '../../services/auth/auth.service';
import { NotificationService } from '../../services/notification/notification.service';
import { UtilService } from '../../services/util.service';
export enum EventType {
  EventTypeTicketCreated = 'ticket_created',
  EventTypeTicketStatusChanged = 'status_changed',
  EventTypeAssign = 'assign',
  EventTypeMention = 'mention',
  EventTypeComment = 'comment',
}

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrl: './top-menu.component.scss'
})
export class TopMenuComponent {
  sessionUser: User

  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
  ) {
    this.sessionUser = this.userService.getCurrentUser()
  }

  userMenuVisibleChange(visible: boolean) {
    if (visible) {
      this.sessionUser = this.userService.getCurrentUser()
    }
  }

  profile() {
    this.router.navigate(['profile'])
  }

  logout() {
    this.authService.logout()
  }
}
